<app-si-dialog modalBodyClasses="flex flex-col h-full w-full overflow-hidden p-4 min-h-[200px]" header="Export to HubSpot">
	<ng-template appDialogBody>
		<ng-container *ngIf="accuracyTier && accuracyTier.length > 0">
			<div class="mb-4 text-center rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm">{{accuracyTierText}}</div>
		</ng-container>

		<div class="flex flex-col overflow-hidden">
			<div *ngIf="isBusy; else notBusyTpl" class="my-12">
				<div class="flex flex-wrap -mx-2">
					<div class="w-full sm:flex-none sm:w-5/6 sm:ml-[8.333333%] text-center px-2">
						<b>{{busyLabel}}</b><br />
						{{busySublabel}}
					</div>
				</div>
			</div>

			<ng-template #notBusyTpl>
				<ng-container [ngSwitch]="pages[currentPageIndex]?.type">
					<ng-container *ngSwitchCase="pageTypes.EXPORT_TYPE">
						<ng-container *ngIf="showExportTypeBox">
							<h3>Export Type</h3>
							Select a lifecycle stage for the contacts you are exporting.
							<br /><br />
							<div class="w-full md:flex-none md:w-full pl-0 pr-0">
								<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
									<mat-label>Filter by lifecycle stage</mat-label>
									<input matInput type="text" placeholder="Filter by lifecycle stage"
										   [(ngModel)]="exportTypeFilter" aria-describedby="basic-addon1">
									<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
								</mat-form-field>
							</div>
							<div class="table-scroll border export-select-container">
								<table class="si-table si-table--striped si-table--hover">
									<thead>
									<tr>
										<th class="flex-none w-full px-2">
											Export Type
										</th>
									</tr>
									</thead>
									<tbody>
									<tr *ngFor="let exportTypeHubSpot of exportTypesHubSpot | filterExportTypes : exportTypeFilter : 'type'">
										<td class="pt-2 pb-2" (click)="setExportType(exportTypeHubSpot.id)">
											{{ exportTypeHubSpot.type }}
										<td class="flex-none w-1/12 relative px-2"><fa-icon *ngIf="exportTypeHubSpot.id === exportType" class="export-select-check-icon" [icon]="['fas', 'check']"></fa-icon>
										</td>
									</tr>
									</tbody>
								</table>
							</div>
						</ng-container>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.LEAD_OWNER">
						<h3>Contact Owner (optional)</h3>
						Select an owner for the selected contacts. This is optional.
						<br /><br />
						<div class="w-full md:flex-none md:w-full pl-0 pr-0">
							<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
								<mat-label>Filter by name or email</mat-label>
								<input matInput type="text" placeholder="Filter by name or email"
									   [(ngModel)]="leadOwnerFilter" aria-describedby="basic-addon1">
								<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
							</mat-form-field>
						</div>
						<div class="table-scroll">
							<table class="table-fixed border pt-1 si-table si-table--striped si-table--hover" *ngIf="leadOwnersLoaded">
								<thead>
								<tr>
									<th> Name </th>
									<th> Email </th>
									<th class="flex-none w-1/12 px-2">
										&nbsp;
									</th>
								</tr>
								</thead>
								<tbody>
								<tr (click)="selectLeadOwner(leadowner.owner_id)"
									*ngFor="let leadowner of leadOwners | filter : leadOwnerFilter | orderBy : 'first_name'">
									<td class="flex-none w-1/2 px-2">{{ leadowner.first_name + " " + leadowner.last_name }}</td>
									<td class="flex-none w-5/12 px-2">{{ leadowner.email }}</td>
									<td class="flex-none w-1/12 relative px-2"><fa-icon *ngIf="leadowner.owner_id === selectedLeadOwner" [icon]="['fas', 'check']"></fa-icon>
									</td>
								</tr>

								<tr *ngIf="(leadOwners | filter: leadOwnerFilter).length === 0 && leadOwnersLoaded">
									<td colspan="2" class="flex-none w-full text-center px-2"><br /><br /><i>No
										Contact Owners Found</i></td>
									<td></td>
								</tr>
								</tbody>
							</table>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.WORKFLOW">
						<ng-container *ngIf="workflows.length>0; else noWorkFlows">
							<h3>Workflows (optional)</h3>
							Select the workflows you want to assign the selected contacts to. This is optional.
							<br /><br />
							<div class="w-full md:flex-none md:w-full pl-0 pr-0">
								<mat-form-field appearance="outline" class="mb-1 w-full no-padding">
									<mat-label>Filter by name</mat-label>
									<input matInput type="text" placeholder="Filter by name" [(ngModel)]="workFlowFilter">
									<fa-icon class="mat-primary si-icon" matPrefix [icon]="['fal', 'magnifying-glass']"></fa-icon>
								</mat-form-field>
							</div>
							<div class="table-scroll">
								<table class="table-fixed border si-table si-table--striped si-table--hover">
									<thead>
									<tr>
										<th>
											Name
										</th>
										<th>
											&nbsp;
										</th>
									</tr>
									</thead>
									<tbody>
									<tr (click)="selectWorkflow(workflow.id)"
										*ngFor="let workflow of workflows | filter : workFlowFilter | orderBy : 'name'">
										<td>{{ workflow.name }}</td>
										<td><fa-icon *ngIf="isWorkflowSelected(workflow.id)" [icon]="['fas', 'check']"></fa-icon></td>
									</tr>
									<tr *ngIf="(workflows | filter: workFlowFilter).length === 0">
										<td colspan="2" class="text-center"><br /><br /><i>No
											Workflows Found</i></td>
									</tr>
									</tbody>
								</table>
							</div>
						</ng-container>
                        <ng-template #noWorkFlows>
							<h3 class="text-center">Workflows (optional)</h3>
							<p class="mb-0 mt-12 text-center">No active HubSpot workflows.</p>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.DUPLICATES">
						<ng-container *ngIf="duplicateCount > 0">
							<h3>Duplicates</h3>
							<div class="flex flex-wrap -mx-2">
								<div class="w-full md:flex-none md:w-1/2 px-2">
									<b>Found {{duplicateCount}} duplicate<span *ngIf="duplicateCount != 1">s</span>:</b>
								</div>
								<div class="w-full md:flex-none md:w-1/2 px-2">
									<b>Resolve Duplicates by:</b>
								</div>
							</div>
							<div class="flex flex-wrap -mx-2">
								<div class="w-full md:flex-none md:w-1/2 pl-4 pb-2 table-scroll">
									<table class="table-fixed border si-table si-table--hover">
										<tbody>
                      @if (data?.contacts) {
                        @for (match of duplicateContactMatches; track match.match_id) {
                          <tr>
                            <td class="flex-none w-full px-2">{{match.contact_name}}</td>
                          </tr>
                        }
                      }
                      @if (data?.company) {
                        @for (match of duplicateCompanyMatches; track match.companyId) {
                          <tr>
                            <td class="flex-none w-full px-2">{{match.companyName}}</td>
                          </tr>
                        }
                      }
										</tbody>
									</table>
								</div>
								<div class="flex-none w-1/2 px-2">
									<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
								</div>
							</div>
						</ng-container>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.DUPLICATES_ASYNC">
						<div class="flex flex-wrap -mx-2 gap-0 py-6">
							<div class="flex-none w-full px-2">
								<h3>Duplicates</h3>
								<p>Resolve Duplicates by:</p>
								<app-duplicate-resolution-radio-group [(ngModel)]="duplicateResolution"></app-duplicate-resolution-radio-group>
							</div>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.JOB_TITLE">
						<div class="flex flex-wrap -mx-2 gap-0 py-12">
							<div class="flex-none w-full px-2">
								<mat-form-field appearance="outline" class="mb-1 w-full">
									<mat-label>Job Name (optional)</mat-label>
									<input matInput type="text" [formControl]="jobTitleControl" placeholder="Job Name">
								</mat-form-field>
							</div>
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.EXPORT_ASYNC">
						<ng-container *ngIf="isLoading$ | async; else finishedAsyncTpl">
							<div class="flex justify-center pt-6">
								<mat-spinner></mat-spinner>
							</div>
						</ng-container>
						<ng-template #finishedAsyncTpl>
							<div class="py-12">
								<p class="mb-0 text-center">Due to the size of your request, you will receive an email when your export is ready. This may take 30 minutes or more during busy times.</p>
							</div>
						</ng-template>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.EXPORT_FINISHED">
                        <ng-container *ngIf="exportedContactCount > 0 && warnings.length !== exportedContactCount; else companyFailedHeader">
                            <h3 class="px-4">Export Succeeded</h3>
                        </ng-container>
                        <ng-template #companyFailedHeader>
                            <h3 class="px-4">Export Failed</h3>
                        </ng-template>

						<ng-container *ngIf="data?.contacts; else companyExportFinished">
							<div class="flex-none w-full pl-4 pb-2" *ngIf="exportedContactCount > 0">
								You have successfully exported {{ exportedContactCount }}
								<span *ngIf="exportedContactCount === 1">contact as a {{ exportTypesSearchable[exportType] }}</span>
								<span *ngIf="exportedContactCount != 1">contacts as {{ exportTypesSearchable[exportType] }}s</span> to HubSpot.
							</div>

							<div *ngIf="warnings.length > 0" class="mt-4 rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm" role="alert">
								All contacts were exported, but for some of the contacts we ran into validation issues.<br /><br />
								<button
									matButton="filled"
									type="button"
									class="mat-small-button mat-error"
									(click)="showWarnings()"
								>view details</button>
							</div>
						</ng-container>
						<ng-template #companyExportFinished>
							<div class="flex-none w-full pl-4 pb-2" *ngIf="exportedCompanyCount > 0">
								You have successfully exported {{ exportedCompanyCount }}
								<span *ngIf="exportedCompanyCount === 1">company</span>
								<span *ngIf="exportedCompanyCount != 1">companies</span> to HubSpot.
							</div>

							<div *ngIf="warnings.length > 0" class="mt-4 rounded-md border border-warning bg-warning-container text-dark px-4 py-3 text-sm" role="alert">
								All Companies were exported, but for some of the companies we ran into validation issues.<br /><br />
								<button
									matButton="filled"
									type="button"
									class="mat-small-button mat-error"
									(click)="showWarnings()"
								>view details</button>
							</div>
						</ng-template>

						<div class="h-full overflow-auto">
							<pre class="h-full text-left warning" *ngIf="isShowingWarnings">{{warnings | json}}</pre>
						</div>

						<mat-accordion class="pt-2">
							<mat-expansion-panel *ngIf="duplicateCount > 0 && duplicateResolution !== 'skip' && data?.contacts">
								<mat-expansion-panel-header>
									<div>
										{{ duplicateCount }} contact<ng-container *ngIf="duplicateCount > 1">s</ng-container> already exist in HubSpot.
										The lifecycle stage {{ exportTypesSearchable[exportType] | titlecase }} was not updated for contacts that already exist.
										All other information was updated based on your settings.
									</div>
								</mat-expansion-panel-header>
								<ng-template matExpansionPanelContent>
									<div class="table-scroll">
										<table class="si-table si-table--hover">
											<tbody>
												@for (duplicate of duplicateContactMatches; track duplicate) {
													<tr>
														<td class="flex-none w-full text-left text-danger px-2">
															<b>{{ duplicate.contact_name }}</b> at
															{{ duplicate.company_name }} found as {{ (exportTypesSearchable[duplicate.export_type] || duplicate.export_type) | titlecase }}
														</td>
													</tr>
												}
											</tbody>
										</table>
									</div>
								</ng-template>
							</mat-expansion-panel>
						</mat-accordion>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.EXPORT_EMPTY">
						<div class="text-center pt-4 pb-4">
							<h3>Nothing to Export</h3>
							All selected {{ data?.contacts ? 'contacts' : 'companies'}} are duplicates and you decided to skip duplicates, so there's nothing left to export.
						</div>
					</ng-container>

					<ng-container *ngSwitchCase="pageTypes.EXPORT_FAILED">
						<h3>Export Failed</h3>
						Your export failed with the following error: <br /><br />
						<pre class="text-danger" style="max-height: 200px; white-space: pre-wrap;">{{exportError}}</pre>
						<br />
						Please resolve the problem in your HubSpot instance and retry or contact SalesIntel support at <a
							href="mailto:support@salesintelio">support&#64;salesintel.io</a>.
					</ng-container>
				</ng-container>
			</ng-template>
		</div>
	</ng-template>

	<ng-template appDialogFooter>
		<div>
			<a matButton="outlined" type="button" class="mr-2" (click)="retryExport()"
			   *ngIf="showRetryButton">Retry</a>
			<button matButton="outlined" type="button" *ngIf="showCancelButton"
					(click)="onClose()">Cancel</button>
		</div>
		<div>
			<button matButton="outlined" type="button" class="mr-2" *ngIf="showPreviousButton"
					(click)="previous()">Previous</button>
			<button matButton="filled" type="button" class="ml-2" *ngIf="!isBusy && showNextButton"
					(click)="next()">Next</button>
			<button matButton="outlined" *ngIf="showCloseButton && !isBusy" class="ml-2"
					(click)="onClose()">Close</button>
		</div>
	</ng-template>
</app-si-dialog>
